document.addEventListener("click", function (e) {

  // Find a banner card
  const card = e.target.closest(".banner-card");
  if (!card) return;

  // If user clicked a button or link already → do nothing
  if (e.target.closest("a, button")) return;

  // Only trigger when clicking the image itself
  if (!e.target.closest(".banner-card_element-media")) return;

  // Find the existing animated button inside the card
  const cta =
    card.querySelector("a.element-button_custom-class") ||
    card.querySelector("a.button");

  if (cta) {
    cta.click(); // triggers the original animation + redirect
  }
});
